import { render, staticRenderFns } from "./ModalAdminStats.vue?vue&type=template&id=c708f80e&scoped=true"
import script from "./ModalAdminStats.vue?vue&type=script&lang=js"
export * from "./ModalAdminStats.vue?vue&type=script&lang=js"
import style0 from "./ModalAdminStats.vue?vue&type=style&index=0&id=c708f80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c708f80e",
  null
  
)

export default component.exports